import * as React from 'react'
import { useEffect, useState } from 'react'

import { PrimaryButton } from '@paytrace/pt-skel/Component'
import PubSub from '@paytrace/pt-skel/Event/PubSub'
import { getLegacyDomain } from '@paytrace/pt-skel/Helper'
import Event from '../../../Event'

interface ViewAndEmailReceiptProps {
  orderId: string
  merchantId: number
  initialEmails: string[]
}

export function viewReceipt (merchantId: string, id: string) {
  window.open(`${getLegacyDomain()}/receipt.pay?tranxid=${id}&id=${merchantId}`, '_blank')
}

export function ViewAndEmailReceipt ({
  orderId,
  merchantId,
  initialEmails,
}: ViewAndEmailReceiptProps) {
  const [isSuccessOpen, setIsSuccessOpen] = useState(false)
  const [sentEmails, setSentEmails] = useState<string[]>([])
  const [availableEmails, setAvailableEmails] = useState<string[]>([...initialEmails])
  const [selectedEmails, setSelectedEmails] = useState<string[]>([])

  useEffect(() => {
    PubSub.pub(Event.GET_CONFIGURED_EMAIL_LIST_REQUEST, {
      merchant_id: merchantId,
      email_type: '6',
    })
  }, [merchantId])

  useEffect(() => {
    const handleEmailListResponse = (response: any) => {
      const emails = new Set([...initialEmails])
      response.forEach((data: { email: string }) => emails.add(data.email))
      setAvailableEmails(Array.from(emails))
    }

    const handleSendReceiptResponse = (emailResponse: any) => {
      if (emailResponse.error_code === 0) {
        const emailsSent = emailResponse.to.split(',').map((e: string) => e.trim())
        setSentEmails(emailsSent)
        setIsSuccessOpen(true)
      } else {
        alert('There was a problem sending the email')
      }
    }

    PubSub.sub(self, Event.GET_CONFIGURED_EMAIL_LIST_RESPONSE, handleEmailListResponse)
    PubSub.sub(self, Event.SEND_SINGLE_EMAIL_RECEIPT_RES, handleSendReceiptResponse)

    return () => PubSub.unsub(self)
  }, [initialEmails])

  const handleEmailToggle = (whom: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      setSelectedEmails((prev) => [...prev, whom])
    } else {
      setSelectedEmails((prev) => prev.filter((email) => email !== whom))
    }
  }

  const handleSendEmail = () => {
    if (selectedEmails.length > 0) {
      PubSub.pub(Event.SEND_SINGLE_EMAIL_RECEIPT_REQ, {
        to: selectedEmails,
        transaction_id: orderId,
        merchant_id: merchantId,
      })
    } else {
      alert('Please select at least one email address.')
    }
  }

  const clickableEmail = (email: string) => (
    <div key={email} className="email-checkbox-item">
      <label className="email-checkbox-label">
        <input
          type="checkbox"
          checked={selectedEmails.includes(email)}
          onChange={handleEmailToggle(email)}
          className="email-checkbox-input"
        />
        {email}
      </label>
    </div>
  )

  return (
    <div className="receipt-inline-container">
      <div className="receipt-single-column">

        <div>
          <strong>Email Receipts To:</strong>
        </div>

        <div className="uid-tranx-app-available-emails">
          {availableEmails.length > 0 ? availableEmails.map(clickableEmail) : <span>No configured emails found.</span>}
        </div>

        <div className="receipt-actions-group">
          <PrimaryButton
            onClick={handleSendEmail}
            className="primary-btn-custom"
          >
            Email Receipt
          </PrimaryButton>

          <PrimaryButton
            onClick={() => viewReceipt(String(merchantId), orderId)}
            className="primary-btn-custom"
          >
            View Receipt
          </PrimaryButton>
        </div>

      </div>

      {isSuccessOpen && (
        <div className="receipt-success-alert">
          <strong>Success:</strong> Receipts have been successfully emailed to: {sentEmails.join(', ')}. Please allow 24-48 hours for delivery.
        </div>
      )}
    </div>
  )
}
/* KEEPING THIS FOR SLICE 2
    <>
      <PrimaryButton
        onClick={() => setIsOpen(true)}
        className="uid-tranx-app-view-and-email primary-btn-custom"
      >
        View and Email Receipt
      </PrimaryButton>

      {isOpen && (
        <div className="receipt-overlay">
          <div className="receipt-modal">
            <div className="receipt-header">
              <h2 className="receipt-title">Receipt</h2>
              <button className="receipt-close-btn" onClick={() => setIsOpen(false)}>✕</button>
            </div>

            <div className="receipt-iframe-container">
              <iframe
                src={`${getLegacyDomain()}/receipt.pay?tranxid=${orderId}&id=${merchantId}`}
                className="receipt-iframe"
                title="Transaction Receipt"
              />
            </div>

            <div className="receipt-email-section">
              <h3 className="receipt-subtitle">Email Receipt</h3>

              <div className="receipt-checkbox-list">
                {availableEmails.map((email) => (
                  <label key={email} className="receipt-checkbox-label">
                    <input
                      type="checkbox"
                      checked={selectedEmails.includes(email)}
                      onChange={handleEmailToggle(email)}
                      className="receipt-checkbox-input"
                    />
                    {email}
                  </label>
                ))}
              </div>

              <div className="receipt-add-recipient">
                <label className="receipt-add-label">Add Recipient</label>
                <div className="receipt-input-row">
                  <input
                    type="email"
                    value={newEmail}
                    onChange={(e) => setNewEmail(e.target.value)}
                    className="receipt-text-input"
                  />
                  <PrimaryButton onClick={handleAddRecipient} className="primary-btn-custom">
                    Add
                  </PrimaryButton>
                </div>
              </div>

              <div className="receipt-action-buttons">
                <PrimaryButton onClick={handleSendEmail} className="primary-btn-custom">
                  Email Receipt
                </PrimaryButton>
                <button className="receipt-cancel-btn" onClick={() => setIsOpen(false)}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {isSuccessOpen && (
        <div className="receipt-overlay">
          <div className="receipt-success-modal">
            <div className="receipt-header">
              <h2 className="receipt-title">Receipt Emailed</h2>
              <button className="receipt-close-btn" onClick={() => setIsSuccessOpen(false)}>✕</button>
            </div>

            <div className="receipt-success-body">
              <p className="receipt-success-text">Receipts have been emailed to:</p>
              <ul className="receipt-success-list">
                {sentEmails.map((email) => (
                  <li key={email} className="receipt-success-item">{email}</li>
                ))}
              </ul>

              <p className="receipt-success-text">
                Please allow 24-48 hours for your receipt to be delivered via email.
              </p>

              <div className="text-center">
                <PrimaryButton onClick={() => setIsSuccessOpen(false)} className="primary-btn-custom">
                  Close
                </PrimaryButton>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
  */
